import { FormInputProps } from '../../../components/form/FormInput';
import { FormSelectProps } from '../../../components/form/FormSelect';

export const inputSharedProps = {
  size: 'small',
  variant: 'standard',
  autoComplete: 'off',
} satisfies Partial<FormSelectProps & FormInputProps>;
